import Spinner from "Components/Spinner/Spinner";
import classes from "./styles.module.scss";

const FullScreenSpinner = ({ size = 40 }) => {
  return (
    <div className={classes.main}>
      <Spinner size={size} />
    </div>
  );
};

export default FullScreenSpinner;
